<script setup lang="ts">
import MobileNavigation from './MobileNavigation.vue'
import SiteFooter from './SiteFooter.vue'
import SiteRail from './SiteRail.vue'
</script>

<template>
  <a class="skip-link" href="#main-content">Skip to main content</a>
  <div class="site-shell">
    <SiteRail />
    <MobileNavigation />
    <div id="main-content" class="site-main" tabindex="-1">
      <slot />
    </div>
    <SiteFooter />
  </div>
</template>
